<article class="popup-wrapper">
    <section class="section-header">
        <span class="header-text">
            Download Investor Return Schedule
        </span>
        <span class="header-desc">
            Download detailed Investor Return Schedule
        </span>
    </section>
    <section class="section-body">
        <div class="date-filter">
            <label class="date-range-txt" for="date-range">Date Range</label>
            <div class="date-range">
                <div class="from-date">
                    <mat-datepicker #fromDate startView="year" panelClass="lrs-month-picker" (monthSelected)="selectMonthAndYear('startDate', $event, fromDate)"></mat-datepicker>
                    <div class="group-icon-input">
                        <img class="calender-icon" alt="calender-icon" src="../../../../../../assets/images/finzy-flex/calender_icon.svg" (click)="fromDate.open()" />
                        <input class="input-from-date" placeholder="From" matInput [(ngModel)]="selectedFromDate" [matDatepicker]="fromDate" readonly>
                    </div>
                </div>
                <span class="to-text">To</span>
                <div class="from-date">
                    <mat-datepicker #toDate startView="year" panelClass="lrs-month-picker" (monthSelected)="selectMonthAndYear('endDate', $event, toDate)"></mat-datepicker>
                    <div class="group-icon-input">
                        <img class="calender-icon" alt="calender-icon" src="../../../../../../assets/images/finzy-flex/calender_icon.svg" (click)="toDate.open()" />
                        <input class="input-from-date" placeholder="To" matInput [(ngModel)]="selectedToDate" [matDatepicker]="toDate" readonly>
                    </div>
                </div>
            </div>
        </div>
        <div class="product-filter">
            <label class="product-type-txt" for="product-type">Select Investment Option</label>
            <div class="product-dropdown">
                <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
                <mat-select placeholder="Select Type" [(ngModel)]="selectedProductType" (ngModelChange)="selectProductType()" class="product-select">
                    <mat-option value="selectType">All</mat-option>
                    <mat-option *ngFor="let productType of productTypes;" [value]="productType">
                        {{ productType }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
    </section>
    <section class="section-footer">
        <button class="back-btn" (click)="onClose()">
            BACK
        </button>
        <button class="download-btn" (click)="onDownload()">
            DOWNLOAD
        </button>
    </section>
</article>